import { reactive } from "vue";

const stateStore = reactive({
  open: false,
  settings: false,
  task: false,
  label: false,
  card: false,
  active: false,
  sidebarCollapsed: localStorage.getItem("sidebarCollapsed") === "true",
  sidebarHoverExpanded: false,
  onChange() {
    stateStore.open = !stateStore.open;
  },
  settingsBtn() {
    stateStore.settings = !stateStore.settings;
  },
  taskModal() {
    stateStore.task = !stateStore.task;
  },
  cardModal() {
    stateStore.card = !stateStore.card;
  },
  activeBtn() {
    stateStore.active = !stateStore.active;
  },
  toggleSidebarCollapsed() {
    stateStore.sidebarCollapsed = !stateStore.sidebarCollapsed;
    localStorage.setItem("sidebarCollapsed", stateStore.sidebarCollapsed ? "true" : "false");
  },
});

export default stateStore;
